var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"mx-3 my-3 d-flex gap-8"},[_c('div',{staticClass:"theme-color-seven"},[_vm._v("คะแนนประเมิน")]),_c('div',[_vm._v(_vm._s(_vm.calculateAVG(_vm.masterData)+" %"))])]),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }